module.exports = __webpack_public_path__ + "assets/img/36_569_big.159ce850.jpg";